import { apiUrl, apiFetch } from "./api";
import { isConsentGranted, subscribePrivacyPreferences } from '../features/privacy/privacyPreferences';

// Navigation cues may use a device voice, but must never start an online service.
export function speakLocalSceneCue(text) {
  if(typeof window === "undefined" || !window.speechSynthesis || !window.SpeechSynthesisUtterance) return;
  const voice=window.speechSynthesis.getVoices().find(v=>v.localService===true && /^en(?:-|_)/i.test(v.lang || ""));
  if(!voice) return;
  const utterance=new window.SpeechSynthesisUtterance(String(text || "").slice(0,1600));
  utterance.voice=voice;
  window.speechSynthesis.speak(utterance);
}

export async function jozSpeak(text) {
  if(!isConsentGranted('voice_actions'))return null;
  try {
    const response = await apiFetch(apiUrl("/api/voice/speech"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        input: String(text || "").slice(0, 1600),
      }),
    });

    if (!response.ok) {
      console.error("❌ Joz speech service error:", response.status);
      throw new Error('Speech service unavailable');
    }

    const blob = await response.blob();
    if(!isConsentGranted('voice_actions'))return null;
    if (blob.size === 0) throw new Error("Empty audio blob returned");

    const url = URL.createObjectURL(blob);
    const audio = new Audio(url);
    const cleanup=()=>{unsubscribe();URL.revokeObjectURL(url);};
    const unsubscribe=subscribePrivacyPreferences(()=>{
      if(!isConsentGranted('voice_actions')){audio.pause();cleanup();}
    });
    audio.addEventListener('ended',cleanup,{once:true});
    audio.addEventListener('error',cleanup,{once:true});
    audio.play().catch(()=>{cleanup();console.warn("Audio play failed.");});

    return audio;
  } catch (err) {
    if(err?.name==='AbortError'||!isConsentGranted('voice_actions'))return null;
    // An unknown/default OS voice may be a network service. Fallback is local.
    speakLocalSceneCue(text);
    return null;
  }
}
